import { createContext } from 'react';
import type { HistoryItem } from '../api/types';

export interface HistoryContextValue {
  history: HistoryItem[];
  persistenceEnabled: boolean;
  addToHistory: (item: Omit<HistoryItem, 'id' | 'timestamp'>) => void;
  clearHistory: () => void;
  removeFromHistory: (id: string) => void;
}

export const HistoryContext = createContext<HistoryContextValue | null>(null);
